// extracted by mini-css-extract-plugin
export default {"caption":"FFX7jabe","blockContent":"Jg1gfJwn","infoBlock":"lnKENnsD","mobile":"mobile"};